/* eslint-disable consistent-return */
/* eslint-disable no-return-await */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "../../../utils/leadsWebEnviroment";

interface BodyProps {
  idsLeadsCompartilhados: string[] | undefined;
}

interface Params {
  idLeadCorretor: string;
  body: BodyProps;
}

export function useExcluirCompartilhamentoLead(props: Params) {
  const registerData = async () => {
    const EXCLUIR_COMPARTILHAMENTO_LEAD = `${leadsWebEnviroment}/app-web/leads/excluir-compartilhamento-lead/v1`;
    return await instance.delete(EXCLUIR_COMPARTILHAMENTO_LEAD, {
      data: props?.body,
    });
  };

  const query = useMutation({
    mutationFn: async () => await registerData(),
    mutationKey: ["excluir_compartilhamento_lead"],
    onSuccess: () => {
      toast.success("O compartilhamento foi excluído com sucesso", {
        autoClose: 10000,
      });
    },
    onError: (error: any) => {
      const errorMessages = error.response.data.notifications.map(
        (item: any) => `\n${item?.message}\n`
      );

      toast.error(errorMessages.join(""), { autoClose: 10000 });
    },
  });
  return query;
}
